export default __webpack_public_path__ + "static/media/meet-youLogo.88360664.png";